import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import '@/i18n';
import '@/styles/fonts';
import '@/styles/reset.css';
import '@/styles/tokens.css';
import '@/styles/animations.css';
import '@/styles/global.css';
import '@/styles/public.css';
import '@/styles/catalogue.css';
import '@/styles/buyer.css';
import '@/styles/admin.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
